<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<section class="search-history-content">
    <div class="history-title">
        <svg class="icon icon-size-16 search-icon">
            <use [attr.href]="listConfig.icon"></use>
        </svg>
        <span *ngIf="listConfig.type=='latest';else otherTitle"
            [nTooltip]="listConfig.operation.tooltip">{{ listConfig.title }}</span>
        <ng-template #otherTitle>
            <span>{{ listConfig.title }}</span>
        </ng-template>
    </div>
    <div *ngIf="classify; else withoutClassify">
        <div *ngFor="let dataItem of dataGroup" class="history-classify">
            <div class="title">{{dataItem.title}}</div>
            <ul *ngIf="dataItem.list&&dataItem.list.length !== 0" class="history-group">
                <li
                    *ngFor="let item of dataItem.list"
                    class="history-list"
                >
                    <div (click)="search(item)" class="list-item">
                        <span *ngIf="item">{{item[listConfig.key ? listConfig.key : 'title']}}</span>
                        <span *ngIf="item" class="sub-title">{{item.subTitle}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <ng-template #withoutClassify>
        <ul *ngIf="listData&&listData.length !== 0" class="history-group">
            <li
                *ngFor="let item of listData"
                class="history-list"
            >
                <div (click)="search(item)" class="list-item">
                    <span *ngIf="item">{{item[listConfig.key ? listConfig.key : 'title']}}</span>
                    <span *ngIf="item" class="sub-title">{{item.subTitle}}</span>
                    <span (click)="cancelItem(item,$event)" *ngIf="listConfig.type=='collected'"
                        [nTooltip]="listConfig.operation.tooltip" class="cancel-icon">
                        <svg class="icon icon-size-14">
                            <use href="#app-icon-search-remove"></use>
                        </svg>
                    </span>
                </div>
            </li>
        </ul>
    </ng-template>
</section>
